export default "__VITE_ASSET__qlzFWtjg__"